export const ENABLE_MEDICARE_CARD_ASSET_2025 = 'ENABLE_MEDICARE_CARD_ASSET_2025';
export const ENABLE_GENDER_AND_IDENTITY_FIELDS =  'ENABLE_GENDER_AND_IDENTITY_FIELDS';
export const ENABLE_RELATIONSHIP_TO_ENROLLEE_FIELDS = 'ENABLE_RELATIONSHIP_TO_ENROLLEE_FIELDS';
export const ENABLE_MULTIPLE_AOE_SELECTION = 'ENABLE_MULTIPLE_AOE_SELECTION';
